import { InjectionToken } from '@angular/core';

export interface AppEnvironment {
	production: boolean;
	apiBaseUrl: string;
	imageBaseUrl: string;
	loggerApiUrl: string;
	isBulk: boolean;
	stripe?: Record<string, { publishableKey: string }>;
}

export const APP_ENVIRONMENT = new InjectionToken<AppEnvironment>('APP_ENVIRONMENT');
